import { useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'

import { concatParams, getHashFromUrl, getParams } from 'utils/getURLData'
import { formatSelectForURL, formatDateForURL } from './utils'
import { IOptions } from 'constants/types/common.types'
import { IInitParams } from 'constants/types/search.types'
import { multiSelectKeys, Key } from 'constants/search-data/search-data'

const useSimpleSyncURL = (params: IInitParams): void => {
  const router = useRouter()
  const queryParams = useMemo(() => getParams(router.asPath), [])
  const { origin } = queryParams

  useEffect(() => {
    const currentParams = params

    const filteredParams = Object.keys(currentParams).reduce((acc, key) => {
      let param

      if (multiSelectKeys.includes(key) && currentParams[key]?.length)
        param = formatSelectForURL(currentParams[key] as IOptions[])
      else if (key === Key.DATES && currentParams[key]?.length) {
        param = formatDateForURL(currentParams[key] as Date[])
      } else if (key === Key.PAGE && currentParams[key]) {
        const pageNumber = Number(currentParams[key])
        param = pageNumber > 1 ? String(pageNumber) : undefined
      } else if (currentParams[key]?.length) param = currentParams[key]

      return param ? { ...acc, [key]: param } : acc
    }, {})

    const initHash = getHashFromUrl(router.asPath)
    const query = concatParams({ ...filteredParams, origin: origin }) + initHash
    const path = router.pathname.replace('/[id]', '')
    const materialTheme = router?.query?.id ? `/${router?.query?.id}` : ''
    const baseUrl = path + materialTheme
    const url = query ? `${baseUrl}?${query}` : baseUrl

    router.replace(url, undefined, { shallow: true })
  }, [params])
}

export default useSimpleSyncURL
